import React from 'react'
import useCallbackStatus from 'hooks/useCallbackStatus'
import { useAuth } from 'context/auth-context'
import { Form } from 'antd'
import { StyledAlert } from 'components'
import {
	StyledPreLoginForm,
	PreLoginView,
	StyledPreLoginAlert,
	PreLoginTitle,
	PreLoginSubTitle,
	PreLoginInput,
	PreLoginInputPassword,
	PreLoginButton,
	PreLoginViewFooter
} from 'views/PreLogin/styled'
import { UtesterLogo, User1stLogo } from '../Logos';

const EMAIL = 'email'
const PASSWORD = 'password'

function Login({ form }) {
	const { login } = useAuth()
	const { isPending, error, run } = useCallbackStatus()
	// const [submitted, setSubmitted] = useState(false)
	const { getFieldDecorator } = form

	const errorMessage = error && error.response && error.response.data && error.response.data.Errors

	const handleSubmit = event => {
		event.preventDefault()
		form.validateFields([EMAIL, PASSWORD], (errors, values) => {
			const { email, password } = values
			if (!errors) {
				//setSubmitted(true)
				run(
					login({
						email,
						password
					})
				)
				//setSubmitted(false)
			}
		})
	}

	return (
		<PreLoginView>
			<StyledPreLoginForm>
				<UtesterLogo />
				<PreLoginTitle>Welcome Back!</PreLoginTitle>
				<PreLoginSubTitle>We’re happy to have you here again!</PreLoginSubTitle>
				{errorMessage && errorMessage.length && (
					<StyledPreLoginAlert>
						<StyledAlert showIcon type="error" message="Error" description={<ul>{errorMessage.map(x => <li key={x}>{x}</li>)}</ul>} radius={4}/>
					</StyledPreLoginAlert>
				)}
				<Form onSubmit={handleSubmit} layout="vertical">
					<Form.Item>
						{getFieldDecorator(EMAIL, {
							validateTrigger: ['onChange', 'onBlur'],
							rules: [
								{
									required: true,
									whitespace: true,
									message: 'required'
								}
							]
						})(<PreLoginInput type="email" placeholder="EMAIL"/>)}
					</Form.Item>

					<Form.Item>
						{getFieldDecorator(PASSWORD, {
							validateTrigger: ['onChange', 'onBlur'],
							rules: [
								{
									required: true,
									whitespace: true,
									message: 'required'
								}
							]
						})(<PreLoginInputPassword type="password" placeholder="PASSWORD"/>)}
					</Form.Item>
					<PreLoginButton size="large" type="primary" htmlType="submit" loading={isPending}>
						SIGN IN
					</PreLoginButton>
				</Form>
				<PreLoginViewFooter>
					<a href="/recover-password">Forgot Your Password?</a>
				</PreLoginViewFooter>
				
			</StyledPreLoginForm>
			<User1stLogo />
		</PreLoginView>
	)
}
export default Form.create({})(Login)
